// DS: MO 4.1.5
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import FragmentsIcon from '@wix/da-ds/pkg/Icons/24x24/Fragments';
import DaDreamupLogoAndText from '@wix/da-ds/pkg/DaDreamupLogoAndText';
import { first } from '../../../../utils/fp';
import UserLink from '../../../../User/Link/UserLink';
import DeviationPromo from '../DeviationPromo';
import CreateButton from './CreateButton';
import s from './DreamupPromo.scss';
const DreamupPromo = ({ block: { contentType, deviations = [] } })=>{
    const { t } = useTranslation();
    const deviation = first(deviations);
    return /*#__PURE__*/ React.createElement(DeviationPromo, {
        deviation: deviation,
        href: deviation && contentType === 'monetization_promotion_dreamup_thirdparty' ? Url.dreamupLink({
            deviationid: deviation.deviationId
        }) : Url.dreamupLink(),
        biData: deviation && BiData({
            evid: 923,
            typeid: deviation.typeId,
            itemid: deviation.deviationId,
            sectionname: BiContextProvidedValue
        }),
        heading: t('sidebar.dreamupPromo.heading'),
        subheading: t('sidebar.dreamupPromo.description'),
        attributionSlot: deviation && deviation.author && t('sidebar.dreamupPromo.attribution', {
            postProcess: 'reactPostprocessor',
            userLink: /*#__PURE__*/ React.createElement(UserLink, {
                className: c(s['attribution-user-link']),
                user: deviation.author,
                showSymbol: false,
                stopPropagation: true
            })
        }),
        logoSlot: /*#__PURE__*/ React.createElement(DaDreamupLogoAndText, {
            className: s['logo'],
            "aria-label": t('sidebar.dreamupPromo.logo.a11y.label'),
            view: "light"
        }),
        ctaSlot: /*#__PURE__*/ React.createElement(CreateButton, {
            icon: FragmentsIcon,
            // This should be removed from the tab order since it isn't a link or a button, we're just using the styles at
            // this point.
            "aria-hidden": "true",
            tabIndex: -1
        }, t('sidebar.dreamupPromo.button.label'))
    });
};
DreamupPromo.displayName = 'DreamupPromo';
export default DreamupPromo;

//# sourceMappingURL=DreamupPromo.js.map